/* eslint-disable react/prop-types */ // TODO: upgrade to latest eslint tooling
import { ArtistTile, ArtistTileProps } from '../artist-tile';
import { FavouriteArtistButtonCompat } from '../compat/favourite-artist-button-compat';
import * as React from 'react';
import { px } from 'csx';
import { classes, style } from 'typestyle';
import { colorSlate } from '../../theme/color';

const styles = style({
  $nest: {
    '& .name-banner': {
      minHeight: px(59),
      backgroundColor: colorSlate.fade(0.5).toString(),
      display: 'flex',
      alignItems: 'center',
    },
  },
});

export type ArtistTileCompatProps = Omit<ArtistTileProps, 'Favourite'>;

const ArtistTileCompat: React.SFC<ArtistTileCompatProps> = ({ className, ...tileProps }) => (
  <ArtistTile
    className={classes(styles, className)}
    Favourite={(buttonProps) => <FavouriteArtistButtonCompat size={34} {...buttonProps} />}
    {...tileProps}
  />
);

export default ArtistTileCompat;
